import { useMutation, useQueryClient } from "@tanstack/react-query";
import { userService } from "../../../services/userService";
import type { UserInfo } from "../../../types";

export const useUpdateUser = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      userId,
      user,
    }: {
      userId: string;
      user: Partial<Omit<UserInfo, "email">>;
    }) => {
      const updated = await userService.patch(userId, user);
      return { updated, userId };
    },
    onSuccess: ({ updated, userId }) => {
      qc.setQueryData<UserInfo[]>(["users"], (current = []) => {
        return current.map((user) => {
          if (user.id === userId) {
            return updated;
          }
          return user;
        });
      });
      qc.invalidateQueries({ queryKey: ["users"] });
    },
  });
};
